import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { fmtRoDate } from "../../lib/dateFmt";

export default function UpcomingProjectsPanel({ navigate }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/projects").then((r) => {
      const today = new Date().toISOString().slice(0, 10);
      const in7 = new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 10);
      const filtered = (r.data || [])
        .filter((p) => p.start_date && p.start_date > today && p.start_date <= in7)
        .sort((a, b) => a.start_date.localeCompare(b.start_date));
      setItems(filtered);
    }).catch(() => {});
  }, []);

  if (!items.length) return null;

  const today = new Date().toISOString().slice(0, 10);

  return (
    <div className="card-flat p-5 mb-8" data-testid="upcoming-projects-panel">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-display text-lg font-bold flex items-center gap-2">
          <span>📅</span>
          Următoarele 7 zile · <span className="text-zinc-500 font-normal text-sm">{items.length} {items.length === 1 ? "proiect" : "proiecte"}</span>
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
        {items.map((p) => {
          const days = Math.ceil((new Date(p.start_date).setHours(0,0,0,0) - new Date(today).setHours(0,0,0,0)) / (1000*60*60*24));
          const isImminent = days <= 3;
          return (
            <button
              key={p.id}
              type="button"
              onClick={() => navigate(`/proiecte`)}
              className={`text-left card-flat p-3 hover:border-[var(--primary)] transition-colors flex items-start gap-2 border-l-4 ${isImminent ? "border-l-violet-600" : "border-l-sky-500"}`}
              data-testid={`upcoming-project-${p.id}`}
            >
              <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold ${isImminent ? "bg-violet-100 text-violet-700" : "bg-sky-100 text-sky-700"} flex-shrink-0`}>
                {days === 1 ? "MÂINE" : `${days}z`}
              </span>
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-sm truncate" title={p.name}>{p.name}</div>
                <div className="text-[10px] text-zinc-500 truncate" title={p.adresa || ""}>📍 {p.adresa || "—"}</div>
                <div className="text-[10px] text-zinc-400 mt-0.5">Start: {fmtRoDate(p.start_date)}{p.min_people > 0 ? ` · 👥 ${p.min_people} pers` : ""}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
